export enum HeaderEvent {
  HomeIconClicked = 'home-icon-clicked',
  SearchButtonClicked = 'search-btn-clicked',
  A2HSButtonClicked = 'a2hs-download-prompt-clicked',
}

export enum SearchEvent {
  ContinuePlayingShown = 'search-continue-play-shown',
  FearturedGamesShown = 'search-featured-games-shown',
  ResultsShown = 'search-results-shown',
  NoResultsShown = 'search-no-results',
}

export enum GameEvent {
  GameCardClicked = 'game-card-clicked',
  SearchResultClicked = 'search-result-clicked',
}
